export const version = "6a3b04981bb6eda376f6fa9a3ac0688277b402b2";
export const footerLabel = "6a3b04981bb6eda376f6fa9a3ac0688277b402b2";
